// Wave surface vertex shader — ivory wax ripples viewed from above

uniform float uTime;
varying vec2  vUv;
varying float vElevation;

void main() {
    vec3 pos = position;

    // Three overlapping sine waves for organic feel
    float e = sin(pos.x * 2.8 + uTime * 1.10) * 0.09
            + sin(pos.x * 1.4 - uTime * 0.65) * 0.055
            + sin(pos.y * 2.2 + uTime * 0.80) * 0.045
            + sin((pos.x - pos.y) * 1.8 + uTime * 0.55) * 0.030;

    pos.z     += e;
    vElevation = e;
    vUv        = uv;

    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
}
